module.exports = __webpack_public_path__ + "img/illu-cut.90b85779.svg";